import useScreenSize from '@/hooks/useScreenSize';
import GenericBottomSheet from '@/shared-components/popups/components/GenericBottomSheet';

import ArtworkAi from './artwork-ai';
import ArtworkRatings from './artwork-ratings';
import ArtworkThoughts from './artwork-thoughts';

import './index.css';

export default function Socials({ selectedSocial, closeSocial }) {
  const screenSize = useScreenSize();
  const isThoughtsView = selectedSocial === 'thoughts' || selectedSocial === 'initial-thoughts';
  const isRatingsView = selectedSocial === 'ratings' || selectedSocial === 'initial-ratings';
  const isAskAiView = selectedSocial === 'ask-ai' || selectedSocial === 'initial-ask-ai';
  const shouldDisplaySocialsSheet = isThoughtsView || isRatingsView || isAskAiView;

  if(screenSize.width <= 900) {
    return (
      <>
        <GenericBottomSheet 
          className="artwork-view-socials-bottom-sheet" 
          open={shouldDisplaySocialsSheet} 
          close={closeSocial} 
          onTouchStart={e => e.stopPropagation()} 
          onTouchEnd={e => e.stopPropagation()} 
          onWheel={e => e.stopPropagation()}
        >
          <div className="artwork-view-socials-bottom-sheet__content-container">
            {isThoughtsView && (
              <ArtworkThoughts closeSocial={closeSocial}/>
            )}

            {isRatingsView && (
              <ArtworkRatings closeSocial={closeSocial}/>
            )}

            {isAskAiView && (
              <ArtworkAi closeSocial={closeSocial}/>
            )}
          </div>
        </GenericBottomSheet>
      </>
    );
  } else {
    return (
      <>
        <div className={`artwork-view-socials__outter-container ${shouldDisplaySocialsSheet ? "mount-animation" : ""}`}>
          <div className="artwork-view-socials__inner-container">
            {isThoughtsView && (
              <ArtworkThoughts closeSocial={closeSocial}/>
            )}
    
            {isRatingsView && (
              <ArtworkRatings closeSocial={closeSocial}/>
            )}

            {isAskAiView && (
              <ArtworkAi closeSocial={closeSocial}/>
            )}
          </div>
        </div>
      </>
    );
  }
}
